import React from 'react'

import { Typography } from '@mui/material'

const Dash = () => (
  <Typography color="text.disabled" component="span" variant="body2">
    —
  </Typography>
)

export default Dash
